/** URL param value for aggregate (all filters) buy recommendation tab. */
export const BUY_REC_FILTER_ALL = "all";

export function isBuyRecAggregateFilter(filterId) {
  return filterId == null || filterId === "" || filterId === BUY_REC_FILTER_ALL;
}
